import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Message } from './models/message';
import { Attachment } from '../../shared/components/attachments/attachment-service/models/attachment-model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicantMessageService {
  apiGatewayUrl: string;

  constructor(private readonly http: HttpClient) {
    this.apiGatewayUrl = environment().apiGatewayUrl;
  }

  submitReply(jobId: number, applicantFileId: number, messageId: number, reply: Message): Observable<any> {
    return this.http.post(`${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/messages/${messageId}/replies`, reply);
  }

  downloadAttachment(jobId: number, applicantFileId: number, messageId: number, attachment: Attachment) {
    const params = new HttpParams()
      .append('location', attachment.location)
      .append('fileName', attachment.name);
    return this.http.get(
      `${this.apiGatewayUrl}jobs/${jobId}/applicant-files/${applicantFileId}/messages/${messageId}/attachments/${attachment.id}/file`,
      { params: params, responseType: 'blob' });
  }
}
